import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const Modal = ({ open, onClose, title, indexLabel, children, actions }) => {
  useEffect(() => {
    if (!open) return undefined;

    const onKey = (event) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', onKey);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
      onClick={onClose}
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className="max-h-[90vh] w-full max-w-4xl overflow-auto rounded-2xl border border-white/10 bg-btc-surface shadow-glow"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-4 border-b border-white/10 px-5 py-4">
          <div>
            <p className="label">
              {indexLabel || 'View'}
            </p>
            <h3 className="mt-1 font-heading text-lg font-semibold leading-tight text-white">
              {title}
            </h3>
          </div>
          <div className="flex items-center gap-2">
            {actions}
            <button
              type="button"
              onClick={onClose}
              aria-label="Close dialog"
              className="icon-btn"
            >
              <X size={18} strokeWidth={2} />
            </button>
          </div>
        </div>
        <div className="p-5 md:p-8">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
